<template>
  <path
    d="M33.3258 18.7666C32.6358 15.3166 29.6058 12.7266 25.9658 12.7266C23.0758 12.7266 20.5658 14.3666 19.3158 16.7666C16.3058 17.0866 13.9658 19.6366 13.9658 22.7266C13.9658 26.0366 16.6558 28.7266 19.9658 28.7266H32.9658C35.7258 28.7266 37.9658 26.4866 37.9658 23.7266C37.9658 21.0866 35.9158 18.9466 33.3258 18.7666Z"
    fill="white"
  />
</template>
